module.exports = __webpack_public_path__ + "static/media/rebirth_33.7c5beede.jpg";